"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedCommunities = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
const SpaceType_1 = require("../../../SpaceType");
class ConnectedCommunities {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.CONNECTED_COMMUNITIES;
        this.description = 'Gain 1 TR if you have at least 3 connected tiles. Increase M€ production 1 step for each influence.';
        this.revealedDelegate = PartyName_1.PartyName.CENTRISTS;
        this.currentDelegate = PartyName_1.PartyName.POPULISTS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const hasThreeConnectedTiles = game.board.spaces.some((space) => {
                if (space.tile === undefined || space.player !== player || space.spaceType === SpaceType_1.SpaceType.COLONY) {
                    return false;
                }
                return game.board.getAdjacentSpaces(space).filter((adj) => adj.tile !== undefined && adj.player === player).length >= 2;
            });
            if (hasThreeConnectedTiles)
                player.increaseTerraformRating();
            const influence = turmoil.getPlayerInfluence(player);
            if (influence > 0)
                player.addProduction(Resources_1.Resources.MEGACREDITS, influence, { log: true });
        });
    }
}
exports.ConnectedCommunities = ConnectedCommunities;
//# sourceMappingURL=ConnectedCommunities.js.map